import React, { useState, useEffect } from "react";
import { Button, Row } from "antd";
import { actionsRender } from "./actionRender";
import { DataTable } from "../../components";
import { columns } from "./columnsTable";
import { useTranslation } from "react-i18next";
import { VerticalAlignTopOutlined } from "@ant-design/icons";
import { onScrollTop } from "../../../utils/scrollTop";
import "./style.css";
import { useNavigate } from "react-router";
import { BeneficiariesActions } from "../../../redux/beneficiaries";
import { useDispatch, useSelector } from "react-redux";

export const BeneficiariesTable = ({
  data,
  selectedRowKeys,
  setSelectedRowKeys
}) => {
  const { t } = useTranslation();
  const navigateTo = useNavigate();
  const dispatch = useDispatch();

  const { current, pageSize, record, sorterFilter } = useSelector(
    state => state.beneficiaries
  );

  const onPaginationChange = (current, pageSize, record, sorterFilter) => {
    dispatch(
      BeneficiariesActions.changeTablePagesize(
        current,
        pageSize,
        record,
        sorterFilter
      )
    );
  };

  const handleReset = () => {
    setSelectedRowKeys([]);
  };

  const handleOnActionRender = () => {
    return actionsRender(handleReset, () => {}, selectedRowKeys, t);
  };

  const onModify = id => {
    navigateTo(`/beneficiarie/${id}`);
  };

  const onDelete = ids => {
    dispatch(BeneficiariesActions.beneficiariesDeleteRequest(ids));
    setSelectedRowKeys([]);
  };

  return (
    <div>
      <DataTable
        items={data}
        columns={columns({onModify, onDelete, record, sorterFilter, t})}
        actionsRender={handleOnActionRender}
        setSelectedRowKeys={setSelectedRowKeys}
        selectedRowKeys={selectedRowKeys}
        current={current}
        pageSize={pageSize}
        onPaginationChange={onPaginationChange}
      />
      <Row className="user-table-button-container">
        <Button
          type="primary"
          shape="circle"
          icon={<VerticalAlignTopOutlined />}
          onClick={onScrollTop}
        />
      </Row>
    </div>
  );
};
